import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "sceneConstructor__bodyWrap"
}
const _hoisted_2 = { class: "sceneConstructor__body" }
const _hoisted_3 = { class: "sceneConstructor__left" }
const _hoisted_4 = { class: "sceneConstructor__contents" }
const _hoisted_5 = { class: "sceneConstructor__contentsWrap" }
const _hoisted_6 = { class: "sceneConstructor__contentsWrapIn" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "sceneConstructor__bottom" }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "sceneConstructor__processing"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_SceneConstructorStartMenu = _resolveComponent("SceneConstructorStartMenu")!
  const _component_SceneConstructorBgMenu = _resolveComponent("SceneConstructorBgMenu")!
  const _component_SceneConstructorBgColorMenu = _resolveComponent("SceneConstructorBgColorMenu")!
  const _component_SceneConstructorOwnBgMenu = _resolveComponent("SceneConstructorOwnBgMenu")!
  const _component_SceneConstructorConstructedBgMenu = _resolveComponent("SceneConstructorConstructedBgMenu")!
  const _component_SceneConstructorLogoMenu = _resolveComponent("SceneConstructorLogoMenu")!
  const _component_SceneConstructorBannerMenu = _resolveComponent("SceneConstructorBannerMenu")!
  const _component_SceneConstructorContents = _resolveComponent("SceneConstructorContents")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "sceneConstructor",
    visible: _ctx.$props.isShown,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.$props.isShown) = $event)),
    modal: true,
    draggable: false
  }, {
    default: _withCtx(() => [
      (_ctx.state && _ctx.state.isLoading)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            isOverlay: ""
          }))
        : _createCommentVNode("", true),
      (_ctx.state && !_ctx.state.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.state.activeView == 'start')
                  ? (_openBlock(), _createBlock(_component_SceneConstructorStartMenu, {
                      key: 0,
                      store: _ctx.store,
                      state: _ctx.state
                    }, null, 8, ["store", "state"]))
                  : _createCommentVNode("", true),
                (_ctx.state.activeView == 'bgMenu')
                  ? (_openBlock(), _createBlock(_component_SceneConstructorBgMenu, {
                      key: 1,
                      store: _ctx.store,
                      state: _ctx.state
                    }, null, 8, ["store", "state"]))
                  : _createCommentVNode("", true),
                (_ctx.state.activeView == 'bgColor')
                  ? (_openBlock(), _createBlock(_component_SceneConstructorBgColorMenu, {
                      key: 2,
                      store: _ctx.store,
                      state: _ctx.state
                    }, null, 8, ["store", "state"]))
                  : _createCommentVNode("", true),
                (_ctx.state.activeView == 'ownBackgrounds')
                  ? (_openBlock(), _createBlock(_component_SceneConstructorOwnBgMenu, {
                      key: 3,
                      store: _ctx.store,
                      state: _ctx.state
                    }, null, 8, ["store", "state"]))
                  : _createCommentVNode("", true),
                (_ctx.state.activeView == 'constructedBackgrounds')
                  ? (_openBlock(), _createBlock(_component_SceneConstructorConstructedBgMenu, {
                      key: 4,
                      store: _ctx.store,
                      state: _ctx.state
                    }, null, 8, ["store", "state"]))
                  : _createCommentVNode("", true),
                (_ctx.state.activeView == 'logos')
                  ? (_openBlock(), _createBlock(_component_SceneConstructorLogoMenu, {
                      key: 5,
                      store: _ctx.store,
                      state: _ctx.state
                    }, null, 8, ["store", "state"]))
                  : _createCommentVNode("", true),
                (_ctx.state.activeView == 'banners')
                  ? (_openBlock(), _createBlock(_component_SceneConstructorBannerMenu, {
                      key: 6,
                      store: _ctx.store,
                      state: _ctx.state
                    }, null, 8, ["store", "state"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_SceneConstructorContents, {
                      store: _ctx.store,
                      state: _ctx.state,
                      onClose: _cache[0] || (_cache[0] = () => _ctx.close())
                    }, null, 8, ["store", "state"])
                  ])
                ])
              ]),
              _hoisted_7
            ]),
            (_ctx.state.isProcessing)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_Loader, { isOverlay: "" })
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_Button, {
        onClick: _cache[1] || (_cache[1] = () => _ctx.close()),
        class: "sceneConstructor__close p-button-outlined p-button-gray p-button-rounded p-button-only-icon"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Icon, { name: "close" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}